import { takeLatest, put, call } from 'redux-saga/effects';
import { loginSuccess, loginFail, 
    logoutSuccess, logoutFail, 
    getAuthUserSuccess, getAuthUserFail,
    getAuthUserModuleSuccess, getAuthUserModuleFail,
	getUserProfileSuccess, getUserProfileFail,
	doChangePasswordSuccess, doChangePasswordFail,
	doForgotPasswordSuccess, doForgotPasswordFail,
	doResetPasswordSuccess, doResetPasswordFail,
	loginAsUserSuccess, loginAsUserFail,
	logoutAsUserSuccess
 } from './authState';
import authservice from '../../services/authservice';
import apiservice from '../../services/apiservice';
import { showLoading, hideLoading } from '../layout/layoutState';
import { setCrudRoute } from '../../redux/crud/crudState';
import { message } from 'antd';

function* loginUser(action) {
  	try {
    
    	yield put(showLoading('Authenticating...'));
    	const { username, password } = action.payload;
		if(username && password){
			const authToken = yield call(authservice.login, username, password); 

			if(authToken){	
				yield put(loginSuccess(authToken));

				yield put({ type: 'auth/getAuthUser' });
				
				yield put({ type: 'auth/getAuthUserModule' });
				
			}
		}else{
			yield put(loginFail('Invalid credentials.'));
		}
  	} catch (error) {
    	console.log(error.message);
    	yield put(loginFail(error.message));
  	}finally{
		yield put(hideLoading());
  	}
}

function* logoutUser(action) {
	yield put(showLoading('Logging out...'));
    try {
      
      	const authToken = yield call(authservice.logout); 
      	yield put(logoutSuccess(authToken));
  		
    } catch (error) {
      	yield put(logoutFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
  }

function* getAuthUser(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUser); 
        yield put(getAuthUserSuccess(user));

    } catch (error) {
        yield put(getAuthUserFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* getAuthUserModule(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUserModules); 
        yield put(getAuthUserModuleSuccess(user));

    } catch (error) {
        yield put(getAuthUserModuleFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* getUserProfile(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUserProfile); 
        yield put(getUserProfileSuccess(user));

    } catch (error) {
        yield put(getUserProfileFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* doChangePassword(action){
	yield put(showLoading());
    try {
        const user = yield call(authservice.doChangePassword, action.payload); 
        yield put(doChangePasswordSuccess(user));

		yield put(setCrudRoute({route:'/console/dashboard', mode: 'list', recordId:0 }));

    } catch (error) {
        yield put(doChangePasswordFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* doForgotPassword(action){
	yield put(showLoading());
    try {
        const result = yield call(authservice.doForgotPassword, action.payload); 
		const { info_message, errorMessage } = result;
		if(info_message){
			message.success(info_message);
			yield put(doForgotPasswordSuccess(info_message));
		}else if(errorMessage){
			message.error(errorMessage);
			yield put(doForgotPasswordFail(errorMessage));
		}
    } catch (error) {
        yield put(doForgotPasswordFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* doResetPassword(action){
	yield put(showLoading());
    try {
        const result = yield call(authservice.doResetPassword, action.payload); 
		const { info_message, errorMessage } = result;
		if(info_message){
			message.success(info_message);
			yield put(doResetPasswordSuccess(info_message));
		}else if(errorMessage){
			message.error(errorMessage);
			yield put(doResetPasswordFail(errorMessage));
		}
    } catch (error) {
        yield put(doResetPasswordFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* loginAsUser(action){
	try {
    	yield put(showLoading('Authenticating...'));
		const authToken = yield call(authservice.loginAs, action.payload); 

		console.log(authToken);
		
		if(authToken){	

			apiservice.setOriginalUserToken(authservice.getAccessToken());
			apiservice.setOriginalTokenExpiresAt(apiservice.getTokenExpiresAt());
			apiservice.setToken(authToken.access_token);
			apiservice.setTokenExpiresAt(authToken.expires_at);
			apiservice.setIsImpersonating(1);
			apiservice.deleteUserInfo();
			yield put(loginAsUserSuccess(authToken));

			yield put({ type: 'auth/getAuthUser' });
			
			yield put({ type: 'auth/getAuthUserModule' });

			yield put(setCrudRoute({route:'/console/dashboard', mode: 'list', recordId:0 }));
			
		}
  	} catch (error) {
    	console.log(error.message);
    	yield put(loginAsUserFail(error.message));
  	}finally{
		yield put(hideLoading());
  	}
}

function* logoutAsUser(){
	try {
    	yield put(showLoading('Switching back...'));
		const authToken = yield call(authservice.logoutAs); 

		apiservice.setToken(apiservice.getOriginalUserToken());
		apiservice.getTokenExpiresAt(apiservice.getOriginalTokenExpiresAt());
		apiservice.deleteOriginalUserToken();
		apiservice.setIsImpersonating(0);
		apiservice.deleteOriginalTokenExpiresAt();
		apiservice.deleteUserInfo();
		yield put(logoutAsUserSuccess(apiservice.getOriginalUserToken()));

		yield put({ type: 'auth/getAuthUser' });
		
		yield put({ type: 'auth/getAuthUserModule' });

		yield put(setCrudRoute({route:'/console/act-as-user', mode: 'list', recordId:0 }));
			
  	} catch (error) {
    	console.log(error.message);
    	yield put(loginAsUserFail(error.message));
  	}finally{
		yield put(hideLoading());
  	}
}

function* authSaga() {
  	yield takeLatest('auth/loginRequest', loginUser);
  	yield takeLatest('auth/logoutRequest', logoutUser);
  	yield takeLatest('auth/getAuthUser', getAuthUser);
  	yield takeLatest('auth/getAuthUserModule', getAuthUserModule);
	yield takeLatest('auth/getUserProfile', getUserProfile);
	yield takeLatest('auth/doChangePassword', doChangePassword);
	yield takeLatest('auth/doForgotPassword', doForgotPassword);
	yield takeLatest('auth/doResetPassword', doResetPassword);
	yield takeLatest('auth/loginAsUser', loginAsUser);
	yield takeLatest('auth/logoutAsUser', logoutAsUser);
}

export default authSaga;
